module.exports = __webpack_public_path__ + "img/bookmarks.0cf21531.jpg";